/**
 * A band over a run of columns — `docs/plans/screener-bands.md`.
 *
 * The period first, in small caps and `accentPurple`, and **never clipped**;
 * the name after it, clipped with an ellipsis to the band's width (owner,
 * 2026-09-29). The whole thing spelled out in the tooltip, which the group def
 * carries (`bandTitle`).
 */

import type { IHeaderGroupParams } from "ag-grid-community";

export interface BandHeaderParams extends IHeaderGroupParams {
  /** `w`, `2w`, `m` — or `""` for daily, which shows no prefix. */
  period?: string;
}

export function BandHeader({ displayName, period }: BandHeaderParams) {
  return (
    <div style={ROW}>
      {period ? <span style={PERIOD}>{period}</span> : null}
      <span style={NAME}>{displayName}</span>
    </div>
  );
}

const ROW: React.CSSProperties = {
  display: "flex",
  alignItems: "baseline",
  gap: 4,
  width: "100%",
  minWidth: 0,
  overflow: "hidden",
  fontSize: 11,
};

const PERIOD: React.CSSProperties = {
  flex: "0 0 auto",
  fontVariant: "small-caps",
  fontWeight: 700,
  letterSpacing: "0.02em",
  color: "var(--qf-accent-purple)",
};

const NAME: React.CSSProperties = {
  flex: "1 1 auto",
  minWidth: 0,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  color: "var(--qf-text-secondary)",
  fontWeight: 600,
};

/**
 * The header lines and the band's edge. The lines show only under the grid
 * root's `qf-live-window` class, so crossing the open is a class change, not a
 * rebuild of the column definitions.
 */
export const BAND_STYLE = `
.qf-live-window .qf-mark-live { box-shadow: inset 0 -2px 0 var(--qf-warn); }
.qf-live-window .qf-mark-computed { box-shadow: inset 0 -2px 0 var(--qf-accent-blue); }
.qf-screener-island .qf-band { border-bottom: 1px solid var(--qf-border); }
`;
